<template>
  <div>
    <v-card max-width="300" elevation="0">
      <v-card-text class="pa-0">
        <v-card-text class="color-wallet" fill-dot rigth>
          <span style="color: #FFFFFF">{{
            getAmountToSetWallet
              ? new Intl.NumberFormat("de-DE").format(getAmountToSetWallet) +
                " Kzs"
              : ""
          }}</span>
        </v-card-text>
        <v-form novalidate ref="form" v-model="valid" lazy-validation>
          <v-text-field
            label="Transferir para:"
            :value="getNameToTransfer"
            required
            filled
            disabled
          ></v-text-field>
          <v-card-actions>
            <v-btn color="deep-purple lighten-2" text block @click="setConfirm">
              <v-icon>mdi-transfer</v-icon>
              Confirmar
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapHelper } from "@/store/helper";
import eventBus from "../../../../main";

export default {
  name: "FormConfirmTransferWallet",
  data: () => ({
    disabled: false,
    showNotify: false,
    dialog: false,
    valid: true,
    value: true,
    loading: false,
    cellphone: "",
    cellphoneRules: [
      v => !!v || "Telefone é requerido",
      v => /^[9]+[1-9]\d{7}$/.test(v) || "Telefone inválido"
    ]
  }),
  methods: {
    setConfirm() {
      //this.$store.dispatch("transferToAnotherWallet");
      eventBus.$emit("pinConfirm", true);
      this.$store.dispatch("closeDataPin");
    }
  },
  computed: {
    ...mapHelper
  }
};
</script>

<style scoped>
.color-wallet {
  min-height: 80px;
  background-color: #26a69a;
  text-align: center;
  padding-top: 31px;
  display: block;
  font-size: 18px;
}
</style>
